import styled from 'styled-components';

export const GlobalHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 72px;
  overflow-y: hidden; 
  background-color: ${(props) => props.background ? props.background : "#1E1E1E"};
`;

export const GlobalHeaderLogo = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 18px;
`;